import { Column, Element } from '@vuddy/components';
import Image from 'next/image';

const GachaStockEmpty = () => {
  return (
    <Column alignItems="center" justifyContent="center" marginTop="gap_4xl">
      <Image
        src={'/images/gacha/rank_empty.png'}
        width={160}
        height={96}
        alt="stock_empty"
      />
      <Element
        marginTop="gap_3xl"
        typography="captionBase"
        color="whitePrimary">
        가챠 참여하고 랭킹에 도전해보세요!
      </Element>
    </Column>
  );
};

export default GachaStockEmpty;
